import {
  Button,
  Card,
  styled,
  Tabs,
  TextField,
  withStyles,
} from '@material-ui/core';
import { theme as customTheme } from 'theme';

export const StyledRadio = styled('div')(({ customStyle = {} }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  backgroundColor: '#F3F3F3',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  padding: '0px 8px',
  height: 24,
  ...customStyle,
}));

export const CustomTabs = styled(Tabs)({
  maxWidth: 584,
  margin: '0 auto 10px',
  '& .MuiButtonBase-root': {
    width: '50%',
    borderBottom: '1px solid white',
    maxWidth: '100%',
  },
  '& .MuiTab-wrapper': {
    textTransform: 'capitalize',
  },
});

export const ActionLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
});

export const StyledButton = styled(Button)({
  backgroundColor: customTheme.colors.primary.red,
  minWidth: 184,
  height: 40,
  padding: '10px 16px',
  textTransform: 'unset',
  '&:hover': {
    color: customTheme.colors.dark.red,
    background: customTheme.colors.light.red,
  },
  '&:disabled': {
    color: customTheme.colors.greyScale.white,
    background: customTheme.colors.light.red + ' !important',
    opacity: 0.23,
  },
});

export const CustomFormTextField = withStyles((theme) => ({
  root: {
    width: '95%',
    marginLeft: 8,
    marginBottom: 20,
    '& .MuiFormControl-root': {
      width: '95%',
    },
    '& label.Mui-focused': {
      color: `${customTheme.colors.primary.black}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${customTheme.colors.primary.black}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${customTheme.colors.primary.black}`,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Suisse-Intl',
      fontSize: 21,
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
      color: `${customTheme.colors.primary.black}`,
      fontSize: 20,
    },
    [theme.breakpoints.down(376)]: {
      '& .MuiInputBase-input': {
        fontFamily: 'Suisse-Intl',
        fontSize: 16,
      },
      '& .MuiFormLabel-root': {
        fontFamily: 'Suisse-Intl',
        color: `${customTheme.colors.primary.black}`,
        fontSize: 16,
      },
    },
  },
}))(TextField);

export const FolderCard = styled(Card)({
  width: '100%',
  maxHeight: 302,
  padding: '32%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative',
});
